<template>
  <div
    :id="fieldkey + '_map'"
    :style="mapSize"
  />
</template>
<script>
import axios from 'axios'
export default {
  props: {
    mapWidth: {
      type: [String, Number],
      default: ''
    },
    mapHeight: {
      type: [String, Number],
      default: ''
    },
    lat: {
      type: [String, Number],
      default: ''
    },
    lng: {
      type: [String, Number],
      default: ''
    },
    countryCode: {
      type: String,
      default: ''
    },
    level: {
      type: [String, Number],
      default: 3
    },
    fieldkey: {
      type: String,
      default: ''
    },
    isFullscreen: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      map: null,
      urlTemplate: {
        ChinaOnlineCommunity_Mobile: 'https://map.geoq.cn/arcgis/rest/services/ChinaOnlineStreetPurplishBlue/MapServer',
        ChinaOnlineCommunity: 'https://map.geoq.cn/arcgis/rest/services/ChinaOnlineCommunity/MapServer',
        ChinaOnlineCommunityENG: 'https://map.geoq.cn/arcgis/rest/services/ChinaOnlineCommunityENG/MapServer',
        ChinaOnlineStreetPurplishBlue: 'https://map.geoq.cn/arcgis/rest/services/ChinaOnlineStreetPurplishBlue/MapServer',
        ChinaOnlineStreetWarm: 'https://map.geoq.cn/arcgis/rest/services/ChinaOnlineStreetWarm/MapServer',
        ChinaOnlineStreetGray: 'https://map.geoq.cn/arcgis/rest/services/ChinaOnlineStreetGray/MapServer'
      }
    }
  },
  computed: {
    mapSize () {
      let styleObj = {
        width: this.mapWidth,
        height: this.mapHeight
      }
      return styleObj
    }
  },
  watch: {
    lat (val) {
      if (!this.map && val) {
        this.init()
      }
    }
  },
  mounted () {
    if (!this.map && this.lat) {
      this.getSource()
    }
  },
  destroyed () {
    this.map = null
  },
  methods: {
    async getSource () {
      await axios.get('https://map.geoq.cn/arcgis/rest/services/ChinaOnlineStreetWarm/MapServer/?f=json').then(res => {
        // console.log(res)
        if (res.status === 200) {
          this.init()
        }
      })
    },
    init () {
      let _this = this
      this.map = window.L.map(this.fieldkey + '_map', {
        center: [this.lat, this.lng],
        zoom: this.level + 3,
        minZoom: 2,
        maxZoom: 18
      })
      window.L.esri.tiledMapLayer({
        url: this.urlTemplate.ChinaOnlineStreetWarm
      }).addTo(this.map)

      window.L.marker([this.lat, this.lng]).addTo(this.map)

      window.L.control.fullscreen({
        position: 'topleft',
        title: 'Show me the fullscreen !',
        titleCancel: 'Exit fullscreen mode',
        content: `<i class="iconfont ${this.isFullscreen ? 'iconicon-test47' : 'iconicon-test46'}" style="color: rgba(0,0,0,0.7);" />`,
        // forceSeparateButton: false, // force seperate button to detach from zoom buttons, default false
        // forcePseudoFullscreen: true, // force use of pseudo full screen even if full screen API is available, default false
        fullscreenElement: false // Dom element to render in full screen, false by default, fallback to map._container
      }).addTo(this.map)

      // events are fired when entering or exiting fullscreen.
      this.map.on('enterFullscreen', () => {
        // console.log('entered fullscreen')
        _this.$bus.$emit('setFullcreen', true)
        let $fullScreenBtn = document.querySelector('.leaflet-control-zoom-fullscreen .iconfont')
        $fullScreenBtn.className = 'iconfont iconicon-test47'
      })

      this.map.on('exitFullscreen', function () {
        // console.log('exited fullscreen')
        _this.$bus.$emit('setFullcreen', false)
        let $fullScreenBtn = document.querySelector('.leaflet-control-zoom-fullscreen .iconfont')
        $fullScreenBtn.className = 'iconfont iconicon-test46'
      })

      // you can also toggle fullscreen from map object
      // this.map.toggleFullScreen()
    },
    updateMap () {
      // this.map.remove()
      window.L.esri.tiledMapLayer({
        url: this.urlTemplate.ChinaOnlineStreetWarm
      }).addTo(this.map)
    }
  }
}
</script>

<style lang="scss" scoped>
.mapbox {
  z-index: 2;
  height: calc(100% - 268px);
}
</style>
